
    document.title = import.meta.env.VITE_APP_TITLE || document.title;
    const faviconLink = document.getElementById('app-favicon');
    if (faviconLink instanceof HTMLLinkElement) {
      faviconLink.href = import.meta.env.VITE_APP_FAVICON || faviconLink.href;
    }
  